import React from "react";
import RightArrowIcon from "../../icons/rightArrowIcon";
import "./link.css"
import {Link} from "react-router-dom";

const CustomLink = (props) => {
    const {label, onClick, to } = props;

    if(to){
       return (
           <Link className={"custom-link"} to={to} onClick={onClick}>
               <RightArrowIcon/>
               <span>{label}</span>
           </Link>
       )
    }

    return (
        <a className={"custom-link"} onClick={onClick}>
            <RightArrowIcon/>
            <span>{label}</span>
        </a>
    )
};

export default CustomLink;